import { useEffect, useRef } from "react"

/**
 * Some components aren't in the DOM at the time of mount. This hook helps delay
 * the focus() call by using setTimeout() to move it to the end of the task
 * queue.
 *
 * See: https://youtu.be/8aGhZQkoFbQ?t=919
 *
 * There's probably a proper way to do this in React though, this is an ugly
 * hack.
 */
export function useFocusOnMount(opt?: {
    /**
     * Disables the entire hook
     */
    disabled?: boolean

    /**
     * Select the text in the input on focus
     */
    selectText?: boolean
}) {

    const disabled = opt?.disabled ?? false
    const selectText = opt?.selectText ?? false
    const inputRef = useRef<HTMLInputElement | null>(null)

    useEffect(() => {

        const timeoutHandle = setTimeout(() => {

            if (!disabled) {
                inputRef.current?.focus()

                if (selectText && inputRef.current?.select) {
                    inputRef.current?.select()
                }
            }

        }, 0)

        return () => {
            clearTimeout(timeoutHandle)
        }

    }, [inputRef, disabled, selectText])

    return inputRef
}
